/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, lockedBy: NonNullable<unknown> }} Explorer_Display_Delete_Skipped_Locked_ToastInputs */

const en_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skipped "${i?.name}" as it's locked by ${i?.lockedBy}`)
};

const fr_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" ignore car il est verrouille par ${i?.lockedBy}`)
};

const de_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" wurde übersprungen, da es von ${i?.lockedBy} gesperrt ist.`)
};

const it_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saltato "${i?.name}" perché bloccato da ${i?.lockedBy}`)
};

const ru_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пропущен "${i?.name}", так как он заблокирован ${i?.lockedBy}`)
};

const es_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se omitió "${i?.name}" porque está bloqueado por ${i?.lockedBy}`)
};

const zh_cn2_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已跳过“${i?.name}”，因为它已被“${i?.lockedBy}”锁定。`)
};

const ja_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」は${i?.lockedBy}によってロックされているためスキップされました`)
};

const hi_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" को छोड़ दिया गया है क्योंकि यह ${i?.lockedBy} द्वारा लॉक किया गया है।`)
};

const pt_pt2_explorer_display_delete_skipped_locked_toast = /** @type {(inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" foi ignorado porque está bloqueado por ${i?.lockedBy}`)
};

/**
* | output |
* | --- |
* | "Skipped \"{name}\" as it's locked by {lockedBy}" |
*
* @param {Explorer_Display_Delete_Skipped_Locked_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_skipped_locked_toast = /** @type {((inputs: Explorer_Display_Delete_Skipped_Locked_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Skipped_Locked_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_delete_skipped_locked_toast(inputs)
	if (locale === "de") return de_explorer_display_delete_skipped_locked_toast(inputs)
	if (locale === "it") return it_explorer_display_delete_skipped_locked_toast(inputs)
	if (locale === "ru") return ru_explorer_display_delete_skipped_locked_toast(inputs)
	if (locale === "es") return es_explorer_display_delete_skipped_locked_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_delete_skipped_locked_toast(inputs)
	if (locale === "ja") return ja_explorer_display_delete_skipped_locked_toast(inputs)
	if (locale === "hi") return hi_explorer_display_delete_skipped_locked_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_delete_skipped_locked_toast(inputs)
	return en_explorer_display_delete_skipped_locked_toast(inputs)
});